import React from "react";
import "./styles.css";
import PostCard from "../UI/post-card";
import { blogArray } from "../../constants/contents";

function Blog({ title }) {
  return (
    <div className="blog">
      <h1>{title}</h1>
      <div className="blog__posts">
        {blogArray.map((blog) => (
          <PostCard
            image={blog.image}
            title={blog.title}
            description={blog.description}
            link={blog.link}
          />
        ))}
      </div>
    </div>
  );
}

export default Blog;
